import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'RequestLog',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RequestLog',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RequestLog',
    column_type: 'datetime',
  },
  target_id: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
  target_type: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
  title: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
  url: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
  params: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
  response: {
    model_name: 'RequestLog',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
